import { BalanceLoader } from 'components/balance-loader'
import React from 'react'
import { TransactionStatus } from 'sdk/omni/omni-transaction-service/types'
import { OmniTransactionStatuses } from 'services'
import { ChainImageWrapper, ChainStatusWrapper, StyledChainStatuses } from '../../style'
import { getChainBadge, getChainFromLayerZeroChain } from '../controllers'

type ChainItemProps = {
  status: TransactionStatus
  chain: number
}

const ChainItemState: React.FC<ChainItemProps> = ({ status, chain }) => {
  const ChainBadge = getChainBadge(chain)
  const getTitle = (deliveryStatus: TransactionStatus) => {
    switch (deliveryStatus) {
      case TransactionStatus.INFLIGHT:
        return 'In Progress'
      case TransactionStatus.DELIVERED:
        return 'Success'
      case TransactionStatus.FAILED:
        return 'Failed'
      default:
        return 'Unknown'
    }
  }
  return (
    <ChainStatusWrapper status={status} title={getTitle(status)}>
      <ChainImageWrapper>{ChainBadge}</ChainImageWrapper>
    </ChainStatusWrapper>
  )
}

const ChainStatusContainer: React.FC<{ transactions: OmniTransactionStatuses[] }> = ({
  transactions,
}) => {
  if (transactions.length === 0) {
    return (
      <StyledChainStatuses>
        <BalanceLoader gray={true} />
      </StyledChainStatuses>
    )
  }
  return (
    <StyledChainStatuses>
      {transactions.map((messageProp, index) => (
        <ChainItemState
          key={`${messageProp.chain}-${index}`}
          status={messageProp.status}
          chain={getChainFromLayerZeroChain(messageProp.chain)}
        />
      ))}
    </StyledChainStatuses>
  )
}

export default ChainStatusContainer
